import { indicationOptionList } from 'lib/clinic/mapper';
import { useCreateProjectOption } from 'lib/hooks/project/useCreateProjectOption';
import { IAdvancedOption, IOptionInfo, IOptionUi } from 'lib/types/clinic/projectTypes';
import React from 'react';
import styled from 'styled-components';
import ProjectOptionCheckbox from './ProjectOptionCheckbox';
import ProjectOptionDropdown from './ProjectOptionDropdown';
import ProjectOptionRadioButton from './ProjectOptionRadioButton';
import ProjectOptionSlider from './ProjectOptionSlider';
import { TValue } from 'lib/types/common';

interface ProjectOptionAdvancedProps {
  optionAdvancedInfoList: IOptionInfo | null;
  advancedOption: IAdvancedOption;
  isPhotogrammetry: boolean;
  onCheckChange: (
    type: 'default' | 'advanced',
    optionKey: string,
    value: TValue,
    isPhotogrammetry: boolean,
  ) => void;
  onOptionChange: (type: 'default' | 'advanced', optionKey: string, value: TValue) => void;
}

const ProjectOptionAdvanced = ({
  optionAdvancedInfoList,
  advancedOption,
  isPhotogrammetry,
  onCheckChange,
  onOptionChange,
}: ProjectOptionAdvancedProps) => {
  return (
    <StyledProjectOptionAdvanced>
      {/* Dropdown */}
      {!isPhotogrammetry &&
        !!optionAdvancedInfoList &&
        !!indicationOptionList.dropdown &&
        !!indicationOptionList.dropdown.find(
          (option: IOptionUi) => option.key in optionAdvancedInfoList,
        ) && (
          <>
            <ProjectOptionDropdown
              type="advanced"
              optionValues={advancedOption}
              optionInfoList={optionAdvancedInfoList}
              onOptionChange={onOptionChange}
            />

            <StyledMidLine />
          </>
        )}
      {/* Radio Button */}
      {!isPhotogrammetry &&
        !!optionAdvancedInfoList &&
        !!indicationOptionList.radio &&
        !!indicationOptionList.radio.find(
          (option: IOptionUi) => option.key in optionAdvancedInfoList,
        ) && (
          <>
            <ProjectOptionRadioButton
              type="advanced"
              optionValues={advancedOption}
              optionInfoList={optionAdvancedInfoList}
              onOptionChange={onOptionChange}
            />
            <StyledMidLine />
          </>
        )}
      {/* Slider */}
      {!isPhotogrammetry &&
        !!optionAdvancedInfoList &&
        !!indicationOptionList.slider &&
        !!indicationOptionList.slider.find(
          (option: IOptionUi) => option.key in optionAdvancedInfoList,
        ) && (
          <ProjectOptionSlider
            type="advanced"
            optionValues={advancedOption}
            optionInfoList={optionAdvancedInfoList}
            onOptionChange={onOptionChange}
          />
        )}
    </StyledProjectOptionAdvanced>
  );
};

const StyledProjectOptionAdvanced = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 30px;
`;

const StyledMidLine = styled.div`
  width: 100%;
  border-bottom: 1px solid #e1e1e7;
`;

export default ProjectOptionAdvanced;
